// Mirrors the server validation (backend chatMediaValidation.service.js) so an
// oversized attachment is refused before a long upload. Documents are bounded by
// the 30 MB upload request limit (base64), not by WhatsApp's 100 MB.
export const MEDIA_SIZE_LIMITS_MB = Object.freeze({ image: 5, video: 16, audio: 16, document: 22 });

export function attachmentSizeError(file, mediaType) {
  const limitMb = MEDIA_SIZE_LIMITS_MB[mediaType];
  if (!limitMb || !file || file.size <= limitMb * 1024 * 1024) return '';
  return `This ${mediaType} is ${(file.size / (1024 * 1024)).toFixed(1)} MB. The limit is ${limitMb} MB.`;
}
